import { useEffect } from "react";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { State } from "../../redux";
import { Track, AdviceScheme } from "client-v2";

import Info from "./steps/Info";
import Header from "./steps/Header";
import Container from "../../components/landing/Container";
import styled from "styled-components";
import { ColorV2 } from "@adoptaunabuelo/react-components";
import TigerLogo from "../../assets/logo/Tiger";
import media from "styled-media-query";

const TigerView = styled.div`
	display: flex;
	align-items: center;
	gap: 24px;
	${media.lessThan("medium")`
       gap: 16px;
    `}
`;

const DonationWizard = (props: Props) => {
	const view = "advice";
	const navigate = useNavigate();
	const currentUser = useSelector((state: State) => state.user.currentUser);
	const isMobile = useSelector((state: State) => state.screen.isMobile);

	useEffect(() => {
		//Track to Mixpanel
		Track.event({
			event: "donation detail view init",
			user: currentUser,
			params: {
				view: view,
			},
		});
	}, []);

	const onNextClick = () => {
		navigate("/consejo/registro");
	};

	return (
		<Container
			style={{ backgroundColor: "white" }}
			contentStyle={{ paddingTop: 0 }}
			headerProps={{
				logoBackgroundColor: "transparent",
				children: (
					<TigerView>
						<TigerLogo type="x" />
						<TigerLogo
							type="logo"
							size={
								isMobile
									? { width: 107, height: 44 }
									: { width: 140, height: 58 }
							}
						/>
					</TigerView>
				),
				childrenPosition: isMobile ? "center" : "left",
				style: { position: "absolute", top: 0 },
			}}
			footerProps={{
				style: { backgroundColor: "transparent" },
				buttonProps: {
					style: {
						width: "100%",
						backgroundColor: ColorV2.surface.primaryHard,
					},
					children: `Quiero ser embajador`,
					onClick: onNextClick,
				},
			}}
		>
			<Header advice={props.advice} />
			<Info />
		</Container>
	);
};

export default DonationWizard;
export interface Props {
	advice: AdviceScheme;
}
